import { keepPreviousData, useQuery } from "@tanstack/react-query";

import relationService from "@services/relation.service";
import { DISCUSSED_TOPICS_QUERY_KEY, QUERY_CACHE_SHORT_EXPIRATION_MS } from "@config/query";

export function useGetDiscussedTopics(contentType: string, objectId: string) {
  return useQuery({
    enabled: Boolean(contentType && contentType.length > 0 && objectId && objectId.length > 0),
    queryKey: [DISCUSSED_TOPICS_QUERY_KEY, contentType, objectId],
    queryFn: async () => {
      return relationService.getDiscussedTopics(contentType, objectId);
    },
    staleTime: QUERY_CACHE_SHORT_EXPIRATION_MS,
    retry: false,
    placeholderData: keepPreviousData,
  });
}
